import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalAddTopicComponent } from '../../e-learning-management/modal-add-topic/modal-add-topic.component';
import { PaymentManagementService } from '../payment-management.service';

@Component({
  selector: 'app-modal-upload-signature',
  templateUrl: './modal-upload-signature.component.html',
  styleUrls: ['./modal-upload-signature.component.scss']
})
export class ModalUploadSignatureComponent implements OnInit {

  modalData: any;
  type: string;

  signature;
  signatureForm: FormGroup;
  signatureInfo

  _name
  _title
  signaturePic
  signatureFile

  signatureStatus: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAddTopicComponent>,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService,
    private paymentManagementService: PaymentManagementService,
  ) {
    this.modalData = data;
    this.type = data.type;
  }

  ngOnInit(): void {

    this.paymentManagementService.getSignature().pipe(
      map(res => {
        // console.log(res);
        if (res.success) {
          if (res.result.length > 0) {
            this.signatureStatus = true;
            this.signatureInfo = res.result[0];
            this._name = this.signatureInfo[0].NAME;
            this._title = this.signatureInfo[0].JOB_TITAL;
            this.signature = this.signatureInfo[0].SIGNATURE_ORIGINAL;
            this.signaturePic = `data:image/png;base64,${this.signatureInfo.base64}`;

            this.signatureForm = this.fb.group({
              name: [this._name, Validators.required],
              title: [this._title, Validators.required],
              signatureImg: [''],
            })
          } else {
            this.signatureStatus = true;
            this.signatureForm = this.fb.group({
              name: ['', Validators.required],
              title: ['', Validators.required],
              signatureImg: ['', Validators.required],
            })
          }
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(null);
      })
    ).subscribe();

  }

  onSignatureSelected(e, signatureForm) {
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);

    const reader = new FileReader();

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {
        this.signature = e.target.files[0].name;

        const file = (e.target as HTMLInputElement).files[0];
        this.signatureFile = file;

        reader.readAsDataURL(file);
        reader.onload = () => {
          this.signaturePic = reader.result as string;
        };
        signatureForm.patchValue({
          signatureImg: file
        });
        signatureForm.get('signatureImg').updateValueAndValidity()
      }
    } else {
      alert('การอัปโหลดรูปภาพรองรับไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  confirm() {

    let response = {
      status: true,
      value: {
        img: this.signatureForm.value.signatureImg,
        name: this.signatureForm.value.name,
        title: this.signatureForm.value.title
      }
    }
    // console.log(response);
    this.dialogRef.close(response);
  }

  closeModal() {
    const response = {
      status: false
    }
    this.dialogRef.close(response);
  }

}
